export enum CurrencyActionType {
  Set = 'currency/set',
}
